/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface StartCalculationRequest
 */
export interface StartCalculationRequest {
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof StartCalculationRequest
     */
    studentIds: Array<ApiUserTasksGetPageParameter> | null;
}

/**
 * Check if a given object implements the StartCalculationRequest interface.
 */
export function instanceOfStartCalculationRequest(value: object): value is StartCalculationRequest {
    if (!('studentIds' in value) || value['studentIds'] === undefined) return false;
    return true;
}

export function StartCalculationRequestFromJSON(json: any): StartCalculationRequest {
    return StartCalculationRequestFromJSONTyped(json, false);
}

export function StartCalculationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartCalculationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'studentIds': (json['studentIds'] == null ? null : (json['studentIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
    };
}

export function StartCalculationRequestToJSON(json: any): StartCalculationRequest {
    return StartCalculationRequestToJSONTyped(json, false);
}

export function StartCalculationRequestToJSONTyped(value?: StartCalculationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentIds': (value['studentIds'] == null ? null : (value['studentIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
    };
}

